import React from 'react';

import { flagStyles } from '../settings';

const SvgAD = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '0px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgAD;
